import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
import {
  AutomaticChargeTypes,
  AutomaticChargeStatusInterface,
  AutomaticChargeDailyReportInterface,
  AutomaticChargeHistoryDetailInterface,
  AutomaticChargePayoutAccountFormInterface,
} from './types';

// Get status
export const getAutomaticChargeStatusRequest = () =>
  action(AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_STATUS_REQUEST);
export const getAutomaticChargeStatusSuccess = (payload: {
  statusData: AutomaticChargeStatusInterface;
}) => action(AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_STATUS_SUCCESS, payload);
export const getAutomaticChargeStatusFailure = () =>
  action(AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_STATUS_FAILURE);

// Accept contract
export const acceptAutomaticChargeContractRequest = (payload: {
  contractVersion: string;
}) =>
  asyncAction(
    AutomaticChargeTypes.ACCEPT_AUTOMATIC_CHARGE_CONTRACT_REQUEST,
    payload,
  );
export const acceptAutomaticChargeContractSuccess = () =>
  action(AutomaticChargeTypes.ACCEPT_AUTOMATIC_CHARGE_CONTRACT_SUCCESS);
export const acceptAutomaticChargeContractFailure = () =>
  action(AutomaticChargeTypes.ACCEPT_AUTOMATIC_CHARGE_CONTRACT_FAILURE);

// Enable (save payout account)
export const enableAutomaticChargeRequest = (
  payload: AutomaticChargePayoutAccountFormInterface,
) => asyncAction(AutomaticChargeTypes.ENABLE_AUTOMATIC_CHARGE_REQUEST, payload);
export const enableAutomaticChargeSuccess = () =>
  action(AutomaticChargeTypes.ENABLE_AUTOMATIC_CHARGE_SUCCESS);
export const enableAutomaticChargeFailure = () =>
  action(AutomaticChargeTypes.ENABLE_AUTOMATIC_CHARGE_FAILURE);

// Update payout account (already enabled)
export const updateAutomaticChargePayoutAccountRequest = (
  payload: AutomaticChargePayoutAccountFormInterface,
) =>
  asyncAction(
    AutomaticChargeTypes.UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_REQUEST,
    payload,
  );

export const updateAutomaticChargePayoutAccountSuccess = () =>
  action(AutomaticChargeTypes.UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_SUCCESS);

export const updateAutomaticChargePayoutAccountFailure = () =>
  action(AutomaticChargeTypes.UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_FAILURE);

// Daily report
export const getAutomaticChargeDailyReportRequest = (payload: {
  startDate: number;
  endDate: number;
}) =>
  action(
    AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_DAILY_REPORT_REQUEST,
    payload,
  );
export const getAutomaticChargeDailyReportSuccess = (payload: {
  dailyReports: AutomaticChargeDailyReportInterface[];
}) =>
  action(
    AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_DAILY_REPORT_SUCCESS,
    payload,
  );
export const getAutomaticChargeDailyReportFailure = () =>
  action(AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_DAILY_REPORT_FAILURE);

// History detail (one day)
export const getAutomaticChargeHistoryDetailRequest = (payload: {
  date: string;
  _page: number;
  _limit: number;
}) =>
  action(
    AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_REQUEST,
    payload,
  );
export const getAutomaticChargeHistoryDetailSuccess = (payload: {
  historyDetail: AutomaticChargeHistoryDetailInterface[];
  historyDetailTotalCount: number;
}) =>
  action(
    AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_SUCCESS,
    payload,
  );
export const getAutomaticChargeHistoryDetailFailure = () =>
  action(AutomaticChargeTypes.GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_FAILURE);
